// Import Bootstrap javascript
import 'bootstrap';
// import 'bootstrap/js/dist/util'
// import 'bootstrap/js/dist/dropdown'
// import 'bootstrap/js/dist/button'
// import 'bootstrap/js/dist/collapse'
// import 'bootstrap/js/dist/carousel'
// import 'bootstrap/js/dist/modal'

// Import custom styles
import '../scss/politicas_de_privacidad.scss';

import './offcanvas.js';

import './sendform';

// Enabling HMR
if (module.hot) {
  module.hot.accept(console.log('Aceptando nuevos cambios...'));
}
